import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=dbc9e8d8&scoped=true&lang=html"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=dbc9e8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc9e8d8",
  null
  
)

export default component.exports